import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/ddm/avfileuploadrequesttask/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/ddm/avfileuploadrequesttask/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/ddm/avfileuploadrequesttask/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const downloadFile = (params, urlParams) => {
  return axios.request({
    url: '/ddm/avfileuploadrequesttask/downloadfile/' + params.id + '/' + params.fileName + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getFoldFileList = (params, urlParams) => {
  return axios.request({
    url: '/ddm/avfileuploadrequesttask/getfoldfilelist/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const makeTask = (params, urlParams) => {
  return axios.request({
    url: '/ddm/avfileuploadrequesttask/maketask/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}
